import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionFeatureAccess, OEVersionTargetsAlphaBetaProds, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEBBraunTargetType as OEBBraunTargetType_, opTargets, OEBBraunStartSelectionContent} from './oe-bbraun-consts';

export const OEBBraunTargetType = OEBBraunTargetType_;

export const OEBBraunTargets = new OEVersionTargetsAlphaBetaProds(
    {
        [OEBBraunTargetType.op]: opTargets,
        [OEBBraunTargetType.anatomy]: [
            OETarget.humanThighKnee,
        ]
    },
    {
        [OEBBraunTargetType.op]: OETarget.surgeryBbraunOneKnee,
        [OEBBraunTargetType.anatomy]: OETarget.humanThighKnee,
    },
    {
        [OEBBraunTargetType.op]: OETarget.surgeryBbraunOneKnee,
        [OEBBraunTargetType.anatomy]: OETarget.humanThighKnee
    }
);

export const OEBBraunFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            anatomyTargetSelection: !isLicensing,
            opTargetSelection: !isLicensing
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if([OELicensingEdition.basic].includes(licensingAccess.edition))  {
                featureAccess.opTargetSelection = true;
            }
            if([OELicensingEdition.viewer, OELicensingEdition.singleUser].includes(licensingAccess.edition))  {
                featureAccess.opTargetSelection = true;
                featureAccess.anatomyTargetSelection = true;
            }
            if(OELicensingEdition.allAbove(OELicensingEdition.extended).includes(licensingAccess.edition))  {
                featureAccess.opTargetSelection = true;
                featureAccess.anatomyTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OEBBraunTargets);

export const OEBBraunStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEBBraunTargets,
    OEBBraunStartSelectionContent
);